import httpHelper from "@/helpers/httpHelper";
// action types
export const GET_URL_BALANCE = "getUrlBalance";
export const GET_BALANCE_SAD = "getBalanceSad";
export const GET_BALANCE_SAM = "getBalanceSam";

// mutation types
export const SET_URL_BALANCE = "setUrlBalance";
export const SET_BALANCE_SAD = "setBalanceSad";
export const SET_BALANCE_SAM = "setBalanceSam";


export default {
    state: {
        
        balanceUrlSaman:{},
        balanceSam:{},
        balanceSad:{},
    },
    getters: {
        /**
         * Get list of detailsSharing for current page
         * @param state
         * @returns {*}
         */
       
        loadedUrlBalance(state) {
            return state.balanceUrlSaman;
        },
        loadedBalanceSam(state) {
            return state.balanceSam;
        },
        loadedBalanceSad(state) {
            return state.balanceSad;
        },

    },
    actions: {
        /**
         * Set the detailsSharing list
         * @param state
         * @param payload
         */
         async [GET_URL_BALANCE](state, payload) {
            await state.commit(SET_URL_BALANCE, payload);
        },
         /**
         * Set the balanc saman Status 
         * @param state
         * @param payload
         */
          async [GET_BALANCE_SAM](state, payload) {
            await httpHelper
                    .getData(payload)
                    .then((response) => {
                        state.commit(SET_BALANCE_SAM, response);
                        
                    })
                    .catch((error) => {
                    })
                    .finally(() => {});
           
        },
         /**
         * Set the balance daderat Status 
         * @param state
         * @param payload
         */
          async [GET_BALANCE_SAD](state, payload) {
            await httpHelper
                    .getData(payload)
                    .then((response) => {
                        state.commit(SET_BALANCE_SAD, response);
                        
                    })
                    .catch((error) => {
                    })
                    .finally(() => {});
           
        },
        
    },
    mutations: {
        
        [SET_URL_BALANCE](state, payload) {
            
            state.balanceUrlSaman = payload;
        },
        [SET_BALANCE_SAD](state, payload) {
            state.balanceSad = payload;
        },
        [SET_BALANCE_SAM](state, payload) {
            state.balanceSam = payload;
        },
       
    }
};